import { render, staticRenderFns } from "./CardPoisonIvy.vue?vue&type=template&id=62e5eed2&"
import script from "./CardPoisonIvy.vue?vue&type=script&lang=js&"
export * from "./CardPoisonIvy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports